import React from "react";
import TextField from "@mui/material/TextField";
import { IconButton } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const PasswordTextField = (props) => {
  const { showPassword, setShowPassword, ...rest } = props;
  return (
    <TextField
      variant="standard"
      {...rest}
      type={showPassword ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <InputAdornment position="start">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => setShowPassword((showPassword) => !showPassword)}
              edge="end"
              size="large">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }} />
  );
};

export default PasswordTextField;
